
<div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>
<mat-card *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      <mat-card-title class="fs-5 mb-0">
        Un-used QR codes
      </mat-card-title>
      <button mat-button color="primary" (click)="createQRcode()"><span class="material-icons">
        add
        </span></button>
    </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table class="abuse-report-table" [columnHeaders]="tableDisplayColumns" [dataSource]="reportList"
        [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate" [showImageColumn]="true"  [imageTemplate]="image">
      </sm-data-table>
    </div>
  </mat-card>
  
  
  <ng-template #menuTemplate let-value>
    <button mat-menu-item (click)="viewDetails(value)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete</span>
    </button>
    
  </ng-template>

  <ng-template #image let-objValue>
    <img
      [src]="
      objValue['documentThumbUrl'] && objValue['documentThumbUrl'] !== null && objValue['documentThumbUrl'] !== 'null'
          ? objValue['documentThumbUrl']
          : '../../../../assets/images/documents.png'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>
